export default __webpack_public_path__ + "static/media/Sanchit kasar.c66c3005.jpeg";